import React from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  Typography,
  Avatar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { generateColor } from "../../helpers/colorGenerator";
import { getInitials } from "../../helpers/getInitials";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: "transparent",
      boxShadow: "none",
      overflow: "visible",
      maxWidth: "100vw",
      maxHeight: "100vh",
    },
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0.85)",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
    background: "linear-gradient(to bottom, rgba(0,0,0,0.7), transparent)",
  },
  headerInfo: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  headerAvatar: {
    width: 40,
    height: 40,
    border: `2px solid rgba(255,255,255,0.3)`,
  },
  headerName: {
    color: "#fff",
    fontWeight: 600,
    fontSize: "1rem",
    textShadow: "0 1px 3px rgba(0,0,0,0.5)",
  },
  closeButton: {
    color: "#fff",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    },
  },
  imageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    paddingTop: 56,
    minWidth: 300,
    minHeight: 300,
    [theme.breakpoints.down("xs")]: {
      minWidth: "80vw",
      minHeight: "60vw",
      padding: theme.spacing(1),
      paddingTop: 48,
    },
  },
  image: {
    maxWidth: "95vw",
    maxHeight: "95vh",
    objectFit: "contain",
    borderRadius: 4,
    boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
  },
  fallbackAvatar: {
    width: 340,
    height: 340,
    fontSize: 120,
    boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
    [theme.breakpoints.down("xs")]: {
      width: 200,
      height: 200,
      fontSize: 72,
    },
  },
}));

const ContactPhotoModal = ({ open, onClose, contact }) => {
  const classes = useStyles();

  if (!contact) return null;

  const hasImage = contact.profilePicUrl && contact.profilePicUrl !== "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.dialog}
      maxWidth={false}
    >
      <div className={classes.header}>
        <div className={classes.headerInfo}>
          <Avatar
            className={classes.headerAvatar}
            src={contact.profilePicUrl}
            style={{ backgroundColor: generateColor(contact.id) }}
          >
            {getInitials(contact.name)}
          </Avatar>
          <Typography className={classes.headerName}>
            {contact.name}
          </Typography>
        </div>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.imageContainer}>
        {hasImage ? (
          <img
            src={contact.profilePicUrl}
            alt={contact.name}
            className={classes.image}
          />
        ) : (
          <Avatar
            className={classes.fallbackAvatar}
            style={{ backgroundColor: generateColor(contact.id) }}
          >
            {getInitials(contact.name)}
          </Avatar>
        )}
      </div>
    </Dialog>
  );
};

export default ContactPhotoModal;
